import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { VariationReportInput } from '../model/query/variation-report-input';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the VariationReport API endpoint.
@Injectable()
export class VariationReportEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  GetVariationInstructionReport(instructionInput: VariationReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: instructionInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'reports/variation/instruction',
      options);
  }

  GetVariationEstimationReport(estimationInput: VariationReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: estimationInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'reports/variation/estimation',
      options);
  }

  GetVariationEstimationReportForDownload(variationId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'reports/variation/estimation/download?variationId=' + variationId,
      options);
  }

  GetAdaptionInstructionReportForDownload(variationId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'reports/variation/adaptioninstruction/download?variationId=' + variationId,
      options);
  }

  GetAdaptionInstructionReport(instructionInput: VariationReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: instructionInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'reports/variation/adaptioninstruction',
      options);
  }

  GetAdaptionEstimationReport(estimationInput: VariationReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: estimationInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'reports/variation/adaptionestimation',
      options);
  }
}
